import React from 'react';

import { Canvas } from '@react-three/fiber';

import { AR } from './ar';

function ARCanvas({
    children,
    patternRatio = 0.5,
    detectionMode = 'mono_and_matrix',
    cameraParametersUrl = 'data/camera_para.dat',
    matrixCodeType = '3x3',
    onCameraStreamReady = () => {},
    onContextReady = () => {},
    ...props
}) {
    return (
        <Canvas camera={{ position: [0, 0, 0], fov: 40, near: 1, far: 1000 }} {...props} touch-action="none">
            <AR
                patternRatio={patternRatio}
                matrixCodeType={matrixCodeType}
                detectionMode={detectionMode}
                cameraParametersUrl={cameraParametersUrl}
                onCameraStreamReady={onCameraStreamReady}
                onContextReady={onContextReady}
            >
                {children}
            </AR>
        </Canvas>
    );
}

export default ARCanvas;
